import { CompanyElement, CompanyAppsElement, CompanyAppElement } from '@models/company';
import axiosInstance from '../../utils/http-client';

export const getCompany = (): Promise<CompanyElement> => {
  return axiosInstance.get(`/api/v1/app/company/details`, {});
};

export const getCompanyApps = (): Promise<CompanyAppsElement> => {
  return axiosInstance.get(`/api/v1/app/company/apps`, {});
};

export const postCompanyApp = (appTitle: string, apiKey: string): Promise<CompanyAppElement> => {
  return axiosInstance.post(`/api/v1/app/company/apps/${appTitle}`, {
    apiKey,
  });
};

export const patchCompanyApp = (appTitle: string, apiKey: string): Promise<CompanyAppElement> => {
  return axiosInstance.patch(`/api/v1/app/company/apps/${appTitle}`, {
    apiKey,
  });
};

export const checkSlug = (slug?: string): Promise<boolean> => {
  return axiosInstance.get(`/api/v1/app/company/checkUrl?companyUrl=${slug}`, {});
};

export const getTags = (title?: string): Promise<Array<{ id: number; title: string }>> => {
  return axiosInstance.get(`/api/v1/app/company/tags`, { params: { title: title } });
};

export const getPositions = (keyword?: string): Promise<Array<{ id: number; title: string; status: string }>> => {
  return axiosInstance.get(`/api/v1/app/positions/list`, { params: { keyword: keyword } });
};

export const patchCompany = (companyValues: CompanyElement): Promise<CompanyElement> => {
  return axiosInstance.patch(`/api/v1/app/company/details`, {
    id: companyValues.id,
    slug: companyValues.slug,
    name: companyValues.name,
    url: companyValues.url,
    email: companyValues.email,
    address: companyValues.address,
    facebook: companyValues.facebook,
    faviconUrl: companyValues.faviconUrl,
    instagram: companyValues.instagram,
    linkedin: companyValues.linkedin,
    logoUrl: companyValues.logoUrl,
    mapUrl: companyValues.mapUrl,
    phoneNumber: companyValues.phoneNumber,
  });
};
